var specGlobal = {};
specGlobal.messages = {};
specGlobal.messages.moreThanOneTabOpened = null;

specGlobal.user = {};
specGlobal.user.updateLastActivityUrl = null;

(function init() {
    var now = new Date();
    document.TimezoneOffset = now.getTimezoneOffset();
    setCookie("TimezoneOffset", document.TimezoneOffset, 1);

    dropdownInit();
    usermenuInit();
    slidingMenu();
})();

function setCookie(key, value, expiresInDays) {
    if (expiresInDays === null ||
        expiresInDays === undefined) {
        expiresInDays = 1;
    }
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiresInDays * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ";secure";
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

function activateModal(modalName, isStatic, showHandler, hideHandler) {

    // prevent duplicate opening of the same modal dialog
    if ($(modalName).is(':visible')) {
        return;
    }

    $(modalName)
        .one("shown.bs.modal",
            function() {
                $("#modalLoading").hide();
            })
        .one("show.bs.modal",
            function() {
                $("#modalLoading").show();
            });

    if ( $(modalName).data("spModalHandler") === undefined) {
        $(modalName).on("shown.bs.modal",
            function() {
                if ($(".modal-backdrop").length > 1) {
                    $(".modal-backdrop").not(':last').remove();
                }
            });

        $(modalName).data("spModalHandler", true);
    }

    if (typeof showHandler !== 'undefined') {
        $(modalName).one("shown.bs.modal", showHandler);
    }

    if (typeof hideHandler !== 'undefined') {
        $(modalName).one("hide.bs.modal", hideHandler);
    }

    if (isStatic) {
        $(modalName).modal({ backdrop: 'static', keyboard: false, show: true });
    } else {
        $(modalName).modal('show');
    }
}

function deactivateModal(modalName) {
    $(modalName).modal('hide');
}

function ChangePicture(imgElement) {
    $(imgElement).replaceWith('<span class="glyphicon glyphicon-picture thumbnailPlaceholder"></span>');
}

function ChangePictureWide(imgElement) {
    $(imgElement).replaceWith('<span class="glyphicon glyphicon-picture thumbnailPlaceholderWide"></span>');
}

$(function () {
    $(document).delegate('*[data-toggle="lightbox"]', 'click', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });
});

function ImageTypeChanged() {
    if ($('#FileIncludeImages').is(':checked') && !$('#chkSimpleDowload').is(':checked')) {
        $('#imageSizeHolder').show();
        $('#downloadTypeHolder').attr('class', 'col-md-3');
        $('#fileTypeHolder').attr('class', 'col-md-3');
        $('#imageTypeHolder').attr('class', 'col-md-3');

    } else {
        $('#imageSizeHolder').hide();        
        $('#downloadTypeHolder').attr('class', 'col-md-4');
        $('#fileTypeHolder').attr('class', 'col-md-4');
        $('#imageTypeHolder').attr('class', 'col-md-4');
    }
}

function FtpExportTypeChanged() {
    var e = document.getElementById("FtpExportTypeDdl");
    var selVal = e.options[e.selectedIndex].value;

    if (selVal === "1") {    //onetime
        $('#ToggleRunNowHolder').show();

        $('#OneTimeHolder').show();
        $('#DailyHolder').hide();
        $('#WeeklyHolder').hide();
        $('#MonthlyHolder').hide();
    }
    else
    {
        $('#ToggleRunNowHolder').hide();
    
        if (selVal === "2") {    //daily
            $('#OneTimeHolder').hide();
            $('#DailyHolder').show();
            $('#WeeklyHolder').hide();
            $('#MonthlyHolder').hide();
        }
        else
            if (selVal === "3") {    //weekly
                $('#OneTimeHolder').hide();
                $('#DailyHolder').hide();
                $('#WeeklyHolder').show();
                $('#MonthlyHolder').hide();
            }
            else
                if (selVal === "4") {    //monthly
                    $('#OneTimeHolder').hide();
                    $('#DailyHolder').hide();
                    $('#WeeklyHolder').hide();
                    $('#MonthlyHolder').show();
                }
    }
}

function MonthlyDaysChanged() {
    if ($('#MonthlyDays').is(':checked')) {
        $('#MonthlyDaysHolder').show();
        $('#MonthlyWeekDaysHolder').hide();
    } else {
        $('#MonthlyDaysHolder').hide();
        $('#MonthlyWeekDaysHolder').show();
    }
}

function ShowModalWithSubmit(formElem, modalElemName) {
    ShowProcessing(modalElemName);
    formElem.form.submit();
}

function ShowProcessing(modalElemName) {
    $(modalElemName).modal({
        backdrop: 'static',
        keyboard: false
    }).modal('show');
}

function HideProcessing(modalElemName) {
    deactivateModal(modalElemName);
}

var editToolTipTimer = 0;
var disableHideEditLink = false;

function ShowEditLink(elem) {
    clearTimeout(editToolTipTimer);
    HideEditLinks();
    $(elem).next().find('.editTooltipClass').show();
    editToolTipTimer = setInterval(function () { HideEditLinks() }, 2000);
}

function DisableHideEditLink() {
    disableHideEditLink = true;
}

function EnableHideEditLink() {
    disableHideEditLink = false;
}

function HideEditLinks() {
    if (!disableHideEditLink)
        $('.editTooltipClass').hide();
    else
        clearInterval(editToolTipTimer);
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function showSuccessToastrMessage(message) {
    showToastrMessage("success", message);
}
function showErrorToastrMessage(message) {
    showToastrMessage("error", message);
}
function showInfoToastrMessage(message) {
    showToastrMessage("info", message);
}

function showInfoDarkToastrMessage(message) {
    setToastrOptions();

    toastr.options.toastClass = 'info-dark-toast';

    toastr.info(message, "");
}

function showToastrMessage(type,message)
{
    setToastrOptions();

    toastr[type](message, "");
}

function setToastrOptions() {
    toastr.options = {
        "closeButton": true,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-center",
        "preventDuplicates": false,
        "onclick": null,
        "timeOut": 5000,
        "extendedTimeOut": 0,
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
        "fadeOut": 500
    };
}

function redirectTo(url) {
    window.location.href = url;
}

function initEmptySortableGridHeaderTooltips(tooltipText) {
    var localTooltipText = tooltipText;
    if (!localTooltipText) {
        localTooltipText = "Click here to sort";
    }

    //selector for kendo grid sortable headers
    $("[role='grid'] thead th[data-role='columnsorter']:not([title])").prop("title", localTooltipText);
}

$.fn.removeAllAttributes = function () {
    this.each(function () {
        var attributes = $.map(this.attributes, function (item) {
            return item.name;
        });

        var element = $(this);
        $.each(attributes, function (i, item) {
            element.removeAttr(item);
        });
    });
};


$.fn.exchangePositionWith = function (selector) {
    var other = $(selector);
    this.after(other.clone());
    other.after(this).remove();
};

function dropdownInit() {
    $(".dropdown-menu-changing").on('click',
        'li a',
        function (e) {
            var $btn = $(e.target).closest(".dropdown").find(".btn:first-child");
            $btn.text($(this).text());
            $btn.val($(this).data('value'));
        });
    $(".dropdown-menu-valued").on('click',
        'li a',
        function (e) {
            var $btn = $(e.target).closest(".dropdown").find(".btn:first-child");
            $btn.val($(this).data('value'));
        });
    //$('.combobox').combobox({ bsVersion: '3' });
};
function dropdownMenuListItemClick(e) {
    var $target = $(e.target);
    var $dropdown = $(e.target).closest(".dropdown");
    $dropdown.find("li").removeClass("active");
    $target.addClass("active");
    $dropdown.find(".value-holder").val($target.data('value'));
    $dropdown.find(".dropdown-toggle").text($target.text());
    $dropdown.find(".dropdown-toggle").trigger("change");
}

// get selected data ( text and value ) of dropdown list of given id
function getDropdownSelectedData(id) {
    var dropdown = $(id).closest(".dropdown");
    if (dropdown) {
        var v = $(dropdown).find(".value-holder").val();
        var t = $(dropdown).find(".dropdown-toggle").text();
        return { text: t, value: v }; // return instance with two properties : value and text
    }
}

function usermenuInit() {
    //$("#userMenu .dropdown-toggle").on("click",
    //    function () {
    //        debugger;
    //        $("#userMenu .caret-down").hide();
    //        $("#userMenu .caret-up").show();
    //    });
    //$("#userMenu a").on("hoverout",
    //    function() {
    //        $("#userMenu .caret-up").hide();
    //        $("#userMenu .caret-down").show();
    //    });
};

/*if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;

    return this.replace(/{(\d+)}/g, function(match, number) { 
      return typeof args[number] !== 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}*/

$(document).ajaxError(function (event, jqxhr, settings, exception) {
    if (jqxhr.status === 401) {
        // unauthorized
        window.location.href = '/';
    }
});

var translatableDifference = 0;
var nextHidden = false;

function slidingMenu() {
    
    //submenu;
    initHorizontalScroll(".submenu-line", ".submenuHolder");

    initHorizontalScroll(".categories-line", ".categoryHolder");
    
}

function initHorizontalScroll(containerSelector, slickHolderSelector, initialSlide) {
    if (!initialSlide) {
        initialSlide = 0;
    }

    var container = containerSelector;
    var holder = slickHolderSelector;

    if ($(container + ' .slick-slider').length) {
        $(container + " .horizontal-scroll").slick('reinit');
        return;
    }

    var lineWidth = $(container).width();
    var totalWidthRow = getTotalWidth(container + " .section");
    if (totalWidthRow > lineWidth) {
        $(container + " " + holder).width(lineWidth);

        $(container + " .horizontal-scroll").slick({
            dots: false,
            infinite: false,
            speed: 300,
            variableWidth: true,
            initialSlide: initialSlide
        });

        $(container + " .slick-prev").on("click",function () {
           if (nextHidden) {
                $(container + " .slick-next").show();
            }
        });

        $(container + " .slick-next").on("click", function () {
            var realTranslation = +$(container + " .slick-track").css("transform").split(",").slice(-2)[0];
            
            translatableDifference = totalWidthRow - lineWidth;
            if (realTranslation + translatableDifference <= 0) {
                $(container + " .slick-next").hide();
                nextHidden = true;
            }
        });
    }
}

function getTotalWidth(selector) {
    var totalWidth = 0;
    $(selector).each(function (i, e) {
        totalWidth = totalWidth + $(e).outerWidth();
    });

    return totalWidth;
}

function autofitInit() {
    $('.autofit').each(function () {
        this.style.height = '27px';

        if (this.clientHeight < this.scrollHeight) {
            this.style.height = this.scrollHeight + "px";
        }
    }).on('keyup', function () {
        this.style.height = '27px';

        if (this.clientHeight < this.scrollHeight) {
            this.style.height = this.scrollHeight + "px";
        }

    });
}

function filterToggleClick(e) {
    var sender = e.srcElement || e.target;
    if (!sender) {
        return;
    }

    var container = $(sender).closest(".toggle-switch-group-container");
    container.toggleClass("in");
}


function filterCloseClick(filterId) {
    if (!filterId || filterId == '') {
        return;
    }

    var filter = $("#" + filterId).closest(".toggle-switch-group-container");
    if (filter) {
        filter.removeClass("in");
    }
}

function addCustomHorizontalScrollToGrid(gridSelector,noFronzenColumns, secondaryScroll) {

    var grid = gridSelector;
    if (!grid) {
        grid = "";
    }

    if ($(grid).length === 0) { // exist grid ?
        return;
    }

    if (noFronzenColumns) {
        $(grid).addClass("scrollbar-inner");

        $(grid).mCustomScrollbar({
            axis: "x", // horizontal scrollbar
            scrollbarPosition: "inside",
            theme: "inset-2-dark",
            mouseWheel: false,
            contentTouchScroll: true, 
            scrollButtons: true,
            advanced: {
                autoUpdateTimeout: 30
            },
            callbacks: {
                onInit: function () {
                    initCustomScrollBar();
                    whileScrollingComments(this);
                },
                whileScrolling: function () {
                    whileScrollingComments(this);
                }
            }

        });
    } else {
        $(grid).find(".k-grid-content").addClass("scrollbar-inner");

        $(grid).find(".k-grid-content").mCustomScrollbar({
            axis: "x", // horizontal scrollbar
            scrollbarPosition: "inside",
            theme: "inset-2-dark",
            mouseWheel: false,
            contentTouchScroll: true, 
            scrollButtons: { enable: true },
            advanced: {
                autoUpdateTimeout: 30
            },
            callbacks: {
                onInit: function () {
                    initCustomScrollBar();
                    whileScrollingComments(this);
                },
                whileScrolling: function () {
                    whileScrollingCustom(grid);
                    whileScrollingComments(this);
                }
            }
        });
        $(grid).find(".k-grid-header-wrap table").css("position", "relative");
    }

    if (secondaryScroll && !noFronzenColumns && !$(grid).find(".additional-scrollbar").length) {
        $(grid).find(".mCSB_inside").prepend($("#additionalScroll").html());
        $(grid).find(".k-grid-content-locked").addClass("frozen-column-top-padding");

        setWidthForAddtionalScroll(grid);
    }
    
    setWheelScrolling('.scrollbar-inner');
}

function whileScrollingCustom(grid) {
    var scroll = $(grid).find('.k-grid-content').find(".mCSB_container").position();
    if (scroll && scroll.left != null) {
        $(grid).find(".k-grid-header-wrap table").css("left", scroll.left + "px");
    }

    var draggerLeft = $(grid).find('.k-grid-content').find(".mCSB_dragger").position();
    if (draggerLeft && draggerLeft.left != null) {
        $(grid).find(".additional-scrollbar .dragger").css("left", draggerLeft.left + "px");
    }
}

function whileScrollingComments(elem) {
        var columnSpan = $('.comment-column .comment-icon-animated');
        var left = ($(elem).width() - $(elem.mcs.content[0]).width() - elem.mcs.left + columnSpan.width() + 2) + 'px';
        columnSpan.css("left", left);
    }

function setWheelScrolling(elemName) {
    $(elemName).on('mousewheel', function (event) {
        if (!event.shiftKey) {
            return;
        }

        var moveBy = event.deltaY * (($(event.currentTarget.mcs.content[0]).width() - $(event.currentTarget).width()) / 3);
        var move = (event.deltaY > 0 ? "+=" : "-=") + Math.abs(moveBy);

        $(event.currentTarget).mCustomScrollbar("scrollTo", move, {
            scrollEasing:'linear'
        });
    });
}

function setWidthForAddtionalScroll(grid) {
    $(grid).find(".k-grid-content .additional-top-scroll").width($(grid).find(".k-grid-content table").width());
    $(grid).find(".dragger").width($(grid).find(".mCSB_dragger").width() + 40);
}

function removeClearButton() {
    $(".k-filtercell .k-autocomplete .k-clear-value").remove();
}

$(window).resize(function() {
    slidingMenu();
});

function getFormData(formId) {
    var unindexed_array = $("#" + formId).serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function (n, i) {
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
}

function getFormDataJson(formId) {
    return JSON.stringify(getFormData(formId));
}

function addLoading(selector) {
    $(selector).addClass("disabled");
    $(selector)
        .append("<i class='loader margin-left-5 fa fa-spinner fa-pulse fa-fw'></i><span class='loader sr-only' >...</span>");
}

function removeLoading(selector) {
    $(selector).removeClass("disabled");
    $(selector)
        .find(".loader")
        .remove();
}

function findIndexIESafe(array, condition) {
    for (var i = 0; i < array.length; i++) {
        // DO NOT TRY TO CHANGE EQUALITY OPERATOR (==) FOR STRICT EQUALITY OPERATOR (===) UNDER NO CIRCUMSTANCES 
        if (array[i] == condition) {
            return i;
        }
    }

    return -1;
}

function getCategoryId() {
    var activeCat = $("#category-tabs div.active a");
    if (activeCat && activeCat.length > 0) {
        return activeCat.data("categoryId");
    }

    activeCat = $("#CategoryDataContent").data("categoryId");
    if (typeof activeCat !== 'undefined')
        return activeCat;

    activeCat = $(".ingredient-category.active");

    if (activeCat.length === 0) {
        activeCat = $(".ingredient-category.special-active");
    }

    if (activeCat && activeCat.length > 0) {
        return activeCat.attr("data-category-id");
    }

    return undefined;
}

function initSticky() {
    var header = $(".sticky-header");
    if (header.closest(".modal-content").length === 0) { // ignore if inside modal dialog
        setTimeout(function () {
            //SPNA-2226: Scroll Bug in SG. Fix for screen flickering when scrolling
            header.floatThead({ position: 'fixed' });
            refocusElement();
        }, 50);
    }
}

function refocusElement() {
    if (window.lastFocus) {
        var elemSelector = '#' + window.lastFocus;
		var elem = $(elemSelector);

        window.lastFocus = null;

        var dropDown = elem.data("kendoDropDownList");
        if (dropDown) {
            dropDown.focus();
            return;
        }

        var numBox = elem.data("kendoNumericTextBox");
        if (numBox) {
            numBox.focus();
            return;
        }
        
        var dropDown = elem.data("kendoMultiSelect");
        if (dropDown) {
            //dropDown.focus();
            var inputF = $(elem).parent('.k-multiselect').find('.k-input');
            multiSelectListFocus(inputF, $(elem));
            return;
        }

        elem.focus();
    }
}

// function to remove html tags without any text inside
function removeEmptyHtmlTags(text) {
    // just remove paragraphs and divs, leave text formatters

    var parsedHtml = $("<text>" + text + "</text>");
    var clearedElems = ['P', 'DIV'];
    $.each(clearedElems, function(i, clearElem) {
        $(parsedHtml).find(clearElem).each(function (j, foundElem) {
            var innerHtml = $(foundElem).html();
            $(foundElem).replaceWith(innerHtml);
        });
    });
    var clearedText = parsedHtml.html().replace('<text>', '').replace('</text>', '');
    return clearedText;
}

// function to view popup message with an "in progress" animation
function showInProgressToastrMessage(message) {

    var progress = '<div class="k-loading-image"></div>';
    var content = '<div class="spec-progress-popup-content"><div class="row"><label>' + message + '</label></div>'
                + '<div class="row">' + progress + '</div></div>';

    toastr.options = {
        "positionClass": "toast-bottom-center",
        "onclick": null,
        "timeOut": 10000,
        "extendedTimeOut": 0,
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
        "tapToDismiss": true,
        "closeButton": true,
        "toastClass": "spec-progress-popup"
    };

    toastr.info(content).css("width", "500px");


}

function isOnScreen(elem) {
    // if the element doesn't exist, abort
    if (elem.length == 0) {
        return null;
    }
    var w = $(window);
    var viewportTop = w.scrollTop();
    var viewportHeight = w.height();
    var viewportBottom = viewportTop + viewportHeight;

    var e = $(elem);
    var top = e.offset().top;
    var height = e.height();
    var bottom = top + height;

    return (top >= viewportTop && bottom <= viewportBottom);
}

var openCommentModal = (function(elem, idName) {
    var running = false;
    return function(elem, idName) {
        if (!running) {
            running = true;
      
            var $comment = $(elem);
            var linkUrl = $comment.data("linkurl");
            var id = $comment.data(idName);
            var specificationIngredientId = $comment.data("specificationingredientid");
            var isIngredientCriteria = $comment.data("isingredientcriteria");
            var isSaveAlwaysAllowed = $comment.data("issavealwaysallowed");

            var data = {
                specificationingredientid: specificationIngredientId,
                isIngredientCriteria: isIngredientCriteria,
                isSaveAlwaysAllowed: isSaveAlwaysAllowed
            };
            data[idName] = id;

            var jsonData = JSON.stringify(data);

            $.ajax({
                url: linkUrl,
                type: "POST",
                data: jsonData,
                dataType: 'html',
                contentType: "application/json",
                success: function (data) {
                    $("#modalWindow").html(data);
                    activateModal("#additionalCommentModal");
                    $comment.css("left", 0).find("i").removeClass('comment-icon-animated');
                    var module = $comment.data("module");
                    $("#modalWindow .saveComment").data({"module":module, "commentElem":$comment});
                },
                error: function () {
            		showErrorToastrMessage("error")
                },
                complete: function () {
                    running = false;
                }
            });
        }
    }
})();

function initCustomScrollBar() {
    $('.mCSB_draggerContainer > .mCSB_draggerRail').remove();
    $('.mCSB_scrollTools .mCSB_dragger .mCSB_draggerRail').appendTo('.mCSB_draggerContainer');
}

function downloadFileFromAjaxPost(data, fileName) {
    var a = document.createElement('a');
    var url = window.URL.createObjectURL(data);
    a.href = url;
    a.download = fileName;
    document.body.append(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

$(document).ready(function() {
    //specGlobal.initBrowserTabCount();
    specGlobal.user.updateLastActivity();
});

specGlobal.initBrowserTabCount = function () {
    var inTabCount = Cookies.get("specInTabCount");
    if (typeof inTabCount !== 'undefined') {
        return;
    }
    Cookies.set("specInTabCount", true);

    var numberOfTabs = Cookies.get("specIsBrowserTabOpened");
    if (typeof numberOfTabs === 'undefined' || numberOfTabs === 'NaN') {
        numberOfTabs = 0;
    } else {
        numberOfTabs = Number(Cookies.get("specIsBrowserTabOpened"));
    }

    numberOfTabs += 1;
    if (numberOfTabs > 1) {
        showErrorToastrMessage(specGlobal.messages.moreThanOneTabOpened);
    }
    Cookies.set("specIsBrowserTabOpened", numberOfTabs);
    
    window.addEventListener("beforeunload", specGlobal.decreaseBrowserTabCount);

    Cookies.remove("specInTabCount");
}

specGlobal.decreaseBrowserTabCount = function () {
    var inTabCount = Cookies.get("specInTabCount");
    if (typeof inTabCount !== 'undefined') {
        return;
    }
    Cookies.set("specInTabCount", true);

    var numberOfTabs = Number(Cookies.get("specIsBrowserTabOpened"));
    numberOfTabs -= 1;
    
    if (numberOfTabs < 0) {
        numberOfTabs = 0;
    }

    Cookies.set("specIsBrowserTabOpened", numberOfTabs);

    Cookies.remove("specInTabCount");
}

specGlobal.user.updateLastActivity = function() {
    if (specGlobal.user.updateLastActivityUrl != null && specGlobal.user.updateLastActivityUrl != '') { 
        $.ajax({
            type: "POST",
            url: specGlobal.user.updateLastActivityUrl,
            cache: false
        });
    }
};